import { render, staticRenderFns } from "./UserDetailOverview.vue?vue&type=template&id=baec7d9a"
import script from "./UserDetailOverview.vue?vue&type=script&lang=js"
export * from "./UserDetailOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports